var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("flexbox", { staticClass: "cell" }, [
    _c("img", {
      staticClass: "cell-head",
      attrs: { src: _vm.fileIcon, alt: "" },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cell-body text-one-line",
        class: { "cursor-pointer": _vm.cursorPointer },
      },
      [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.data.name.length > 20
                ? _vm.data.name.substring(0, 20) + "..."
                : _vm.data.name
            )
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "size" }, [
      _vm._v(
        "\n    (" + _vm._s(_vm._f("getFileSize")(_vm.data.size)) + ")\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cell-foot" }, [
      _vm.previewShow
        ? _c(
            "span",
            {
              staticClass: "xr-text-btn primary",
              on: { click: _vm.previewClick },
            },
            [_vm._v("预览")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "xr-text-btn primary",
          on: { click: _vm.downloadClick },
        },
        [_vm._v("下载")]
      ),
      _vm._v(" "),
      _vm.showDelete
        ? _c(
            "span",
            {
              staticClass: "xr-text-btn delete",
              on: { click: _vm.deleteClick },
            },
            [_vm._v("删除")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }